import React from 'react'

interface Props {
  width?: number
  height?: number
  color?: string
}

const DepartmentIcon: React.FC<Props> = ({ width = 32, height = 32, color = '#333' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21V3H3V21ZM5 5H19V19H5V5Z"
        fill={color}
      />
      <path
        d="M7 7H9V9H7V7ZM11 7H13V9H11V7ZM15 7H17V9H15V7ZM7 11H9V13H7V11ZM11 11H13V13H11V11ZM15 11H17V13H15V11ZM7 15H9V17H7V15ZM11 15H13V17H11V15ZM15 15H17V17H15V15Z"
        fill={color}
      />
    </svg>
  )
}

export default DepartmentIcon
